import { useState, useMemo, useEffect } from "react";

// Components
import Modal from "components/organism/modal-v2";
import Button from "components/v1/Button";

// Assets
import { ReactComponent as XIcon } from "assets/cross.svg";

const ModalKonfirmasi = ({
  onClose,
  isOpen,
  title,
  description,
  leftBtnText,
  rightBtnText,
  rightBtnAction,
  leftBtnAction,
  rightBtnVariant,
  withCounter,
  maxCountDown = 10,
  ...props
}) => {
  const [counter, setCounter] = useState(maxCountDown);

  useEffect(() => {
    if (withCounter) {
      const interval = setInterval(() => {
        setCounter((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [withCounter]);

  const textWithCunter = useMemo(() => {
    if (withCounter && counter > 0) {
      return `${rightBtnText} (${counter})`;
    }
    return rightBtnText;
  }, [rightBtnText, withCounter, counter]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} {...props}>
      <div
        className="w-[400px] z-[42] bg-white rounded-md border-[0.5px] border-solid border-[#ECECEC] 
        shadow-[0px_1px_3px_0px_rgba(16,16,16,0.10),_0px_1px_2px_0px_rgba(16,16,16,0.06)]"
      >
        <div className="flex justify-end px-4 py-2 border-b border-solid border-[#D8D8D9]">
          <XIcon onClick={onClose} />
        </div>

        <div className="px-4 py-2">
          <p className="text-[17px] font-inter-semibold">{title}</p>
          <p className="text-[13px] font-inter text-[#808285]">{description}</p>
        </div>

        <div
          className={
            "flex items-center justify-end gap-4 px-4 py-2 border-t border-solid border-[#D8D8D9]"
          }
        >
          <Button type="secondary" text={leftBtnText} onClick={leftBtnAction} />
          <Button disabled={withCounter && counter > 0} type={rightBtnVariant} text={textWithCunter} onClick={rightBtnAction} />
        </div>
      </div>
    </Modal>
  );
};

const Wrapper = ({ isOpen, ...props }) => {
  if (!isOpen) return null;
  return <ModalKonfirmasi isOpen={isOpen} {...props} />;
};

export default Wrapper;
